import React from "react";
import { Link } from "react-router-dom";

export default function BreadCrumb({
  data,
}: {
  data: Array<{ name: string; link?: string; onClick?: any }>;
}) {
  return (
    <nav className="flex mt-4" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-3 text-base">
        {data
          .filter((item) => item.name)
          .map((item, index) => {
            return (
              <li key={index}>
                <div className="flex items-center">
                  {index === 0 ? null : (
                    <svg
                      aria-hidden="true"
                      className="w-6 h-6 text-gray-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  )}
                  {item.link ? (
                    <Link to={item.link}>
                      <p
                        className={`${index === 0 ? "ml-0" : "ml-2"} font-semibold capitalize  ${
                          item.link == "#"
                            ? "text-gray-700"
                            : "text-customGreen-primary"
                        } 
                    `}
                      >
                        {item.name}
                      </p>
                    </Link>
                  ) : item.onClick ? (
                    <p
                      className={`${index === 0 ? "ml-0" : "ml-2"}  font-semibold capitalize cursor-pointer   ${"text-customGreen-primary"} 
                `}
                      onClick={item.onClick}
                    >
                      {item.name}
                    </p>
                  ) : (
                    <p
                      className={`${index === 0 ? "ml-0" : "ml-2"}  font-semibold capitalize  text-gray-700
                `}
                    >
                      {item.name}
                    </p>
                  )}
                </div>
              </li>
            );
          })}
      </ol>
    </nav>
  );
}
